import { Partner } from '../models/partner.model';
import { getToken, validateAndExtractData } from './api.base.service';

export const getPartners = async (): Promise<Partner[]> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}partner`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      }
    }
  );
  const partners: Partner[] = await validateAndExtractData(response);
  return partners;
};

export const getPartner = async (id: string): Promise<Partner> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}partner/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      }
    }
  );
  const partner: Partner = await validateAndExtractData(response);
  return partner;
};

export const createPartner = async (
  partner: Partial<Partner>
): Promise<Partner> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}partner`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      },
      body: JSON.stringify(partner)
    }
  );
  const createdPartner: Partner = await validateAndExtractData(response);
  return createdPartner;
};

export const updatePartner = async (
  id: string,
  partner: Partial<Partner>
): Promise<Partner> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}partner/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      },
      body: JSON.stringify(partner)
    }
  );
  const updatedPartner: Partner = await validateAndExtractData(response);
  return updatedPartner;
};

export const deletePartner = async (
  id: string
): Promise<{ message: string }> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}partner/${id}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      }
    }
  );
  const result: { message: string } = await validateAndExtractData(response);
  return result;
};

export const updatePartnerRelations = async (
  id: string,
  tenantIds: string[]
): Promise<{ message: string }> => {
  const response = await fetch(
    `${process.env.REACT_APP_REAL_GENIUS_REST}partner/${id}/tenants`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        authorization: getToken()
      },
      body: JSON.stringify({ tenantIds })
    }
  );
  const updatedPartner: { message: string } = await validateAndExtractData(
    response
  );
  return updatedPartner;
};
